<template>
  <card class="parc-card">
    <template v-if="$slots.title">
      <div class="row">
        <div class="col-12">
          <slot name="title"></slot>
          <hr class="mt-0" />
        </div>
      </div>
    </template>

    <div class="row parc-card__body">
      <template v-if="$slots.header">
        <div class="col-2">
          <slot name="header"></slot>
        </div>
      </template>
      <template v-if="$slots.content">
        <div class="col-10">
          <slot name="content"></slot>
        </div>
      </template>
    </div>

    <template v-if="$slots.footer">
      <hr />
      <slot name="footer"></slot>
    </template>
  </card>
</template>

<script setup>
import Card from "./Cards/Card.vue"
</script>

<style lang="scss">
.parc-card {
  z-index: 1 !important;

  &__body {
    min-height: 127px;
  }

  .icon-big {
    position: relative;

    i {
      position: absolute;
      top: -6px;
      left: 3px;
    }
  }

  .numbers {
    font-size: 1.9em;
  }

  @media screen and (max-width: 400px) {
    width: calc(100vw - 30px);
    .icon-big {
      i {
        font-size: 0.7em;
        top: -3px;
        left: 1px;
      }
    }
    .numbers {
      font-size: 1.5em;
    }
  }
}
</style>
